import React from "react";
import styles from "./SkeletonLoader.module.css";

const SkeletonLoader = () => {
    return <div className={styles.skeleton} />;
};

export default SkeletonLoader;
